import { Text, Text_Augmented, Text_AugmentedProps } from '@ubnt/ui-components/aria/Typography/Text';
import bytesFormatter from '@ubnt/ui-components/utils/bytesFormatter';
import { memo, useCallback, useMemo } from 'react';

import { Flex } from 'components/Flex';
import { PhyRateEntry } from 'modules/links/slice';

interface LinkTooltipContentProps {
  signalLabel?: string;
  signalLabelParams?: {
    label: Text_AugmentedProps['children'];
    color: Text_AugmentedProps['color'];
  };
  mcs?: number;
  phyRatesMap?: PhyRateEntry[];
  speed?: number;
}

const textStyle = {
  lineHeight: 1.6,
};

const LinkTooltipContentImpl = (props: LinkTooltipContentProps) => {
  const { signalLabel, signalLabelParams, phyRatesMap, speed } = props;

  const getPhyRateLabel = useCallback((phyRate: number) => bytesFormatter((phyRate * 1000000) / 8, 'bitrate'), []);

  const speedLabel = useMemo(() => {
    if (!speed) {
      return '-';
    }
    return bytesFormatter((speed * 1000000) / 8, 'bitrate');
  }, [speed]);

  return (
    <div>
      <Flex justifyBetween>
        <Text size="small" style={textStyle} color="text-1">
          <span>Signal </span>
          {signalLabelParams != null ?
            <Text_Augmented color={signalLabelParams.color}>{signalLabelParams.label}</Text_Augmented>
          : undefined}
        </Text>
        <Text size="small" style={textStyle}>
          {signalLabel}
        </Text>
      </Flex>
      <Flex justifyBetween>
        <Text size="small" style={textStyle} color="text-1">
          Real-World Speed
        </Text>
        <Text size="small" style={textStyle}>
          {speedLabel}
        </Text>
      </Flex>
      {phyRatesMap?.map((phyRateData) => {
        const { bandLabel, mcs, phyRate } = phyRateData;
        const phyRateLabel = getPhyRateLabel(phyRate);
        return (
          <Flex key={bandLabel} justifyBetween>
            <Text size="small" style={textStyle} color="text-1">
              {bandLabel} MCS {mcs}
            </Text>
            <Text size="small" style={textStyle}>
              {phyRateLabel}
            </Text>
          </Flex>
        );
      })}
    </div>
  );
};

export const LinkTooltipContent = memo(LinkTooltipContentImpl);
